_ = require 'underscore'
CustomFieldBadgesView = require 'views/custom-field/custom-field-badges-view'
CustomFieldCheckboxCardDetailBadgeView = require 'views/custom-field/custom-field-checkbox-card-detail-badge-view'
CustomFieldDateCardDetailBadgeView = require 'views/custom-field/custom-field-date-card-detail-badge-view'
CustomFieldListCardDetailBadgeView = require 'views/custom-field/custom-field-list-card-detail-badge-view'
CustomFieldNumberCardDetailBadgeView = require 'views/custom-field/custom-field-number-card-detail-badge-view'
CustomFieldTextCardDetailBadgeView = require 'views/custom-field/custom-field-text-card-detail-badge-view'
trackUe = require 'debug/trackUe'

CUSTOM_FIELDS_ID = require 'data/custom-fields-id'

viewForType = (type) ->
  switch type
    when 'checkbox' then CustomFieldCheckboxCardDetailBadgeView
    when 'date' then CustomFieldDateCardDetailBadgeView
    when 'list' then CustomFieldListCardDetailBadgeView
    when 'number' then CustomFieldNumberCardDetailBadgeView
    when 'text' then CustomFieldTextCardDetailBadgeView

module.exports = class CustomFieldCardDetailBadgesView extends CustomFieldBadgesView
  tagName: 'div'
  className: -> 'custom-field-detail-badges-grid'

  render: ->
    subviews = @model.getBoard().customFieldList.map (customField) =>
      if !customField.visible()
        return null
      customFieldItem = @model.getCustomFieldItem(customField.id)
      if !@model.editable() && customFieldItem?.isEmpty()
        return null
      if customFieldItem? || @model.editable()
        uniqId = @idForBadge(customField.toJSON(), customFieldItem?.toJSON())
        @subview viewForType(customField.get 'type'), @model, { customFieldItem, customField }, uniqId

    compacted = _.compact(subviews)
    @ensureSubviews compacted

    if compacted.length > 0 && _.some(@model.customFieldItemList.models, (cfi) -> !cfi.isEmpty())
      @trackBadges()

    @

  trackBadges: ->
    if !@trackedDetailsBadges
      @trackedDetailsBadges = true
      trackUe('card details', 'views', 'Power-Up', '', '', 'card-detail-badges', CUSTOM_FIELDS_ID)



// WEBPACK FOOTER //
// ./app/scripts/views/custom-field/custom-field-card-detail-badges-view.coffee